define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'submit':'.ct_btn8',
            'form': '#withdrawal_form',
            'amount': '#amount',
            'totalBonus': '#total_bonus',
            'balance': '#balance',
            'withdrawableSymbol': '#withdrawable_symbol',
            'withdrawableAmount': '#withdrawable_amount',
            'accountNoSelect': '#mt4_account_no',
            'currencyAbbr': '#currency_abbr',
            'transferAlert': '#transfer_alert',
            'transferAlertMessage': '#transfer_alert_message',
        },

        events:{
            'click @ui.submit' : 'submit',
            'keyup @ui.amount': function(e){
                // Prevent anything other than 1-9 and . to be written in the amount input.
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g,''));
            },
            'change @ui.accountNoSelect': function(e){
                this.updateFinancial();
                this.blockTransfer(this.ui.accountNoSelect.val());
            },
            'change @ui.currencyAbbr': function(e){
                this.updateFinancial();
            }
        },

        blockSubmitBtn() {
            if(window.block_submit_btn && window.block_submit_btn == 'yes') {
                this.ui.submit.attr('disabled', true);
            }
        },

        blockTransfer: function(mt4AccountNo) {
            const that = this
            const account_info = window.accounts_info.find(a => a.mt4AccountNo == mt4AccountNo);
            if(account_info && account_info.canTransfer == false) {
                that.ui.transferAlert.removeClass('hidden')
                that.ui.transferAlertMessage.text(`(${mt4AccountNo}) ${account_info.reasons[0]}`)
                that.ui.submit.attr('disabled', true);
            }
            else {
                that.ui.transferAlert.addClass('hidden')
                that.ui.transferAlertMessage.text('');
                that.ui.submit.attr('disabled', false);
            }
        },
        
        updateFinancial: function(){
            var that = this;
            $.ajax({
                url: '/rest_withdrawal/get_financial_info',
                data:{
                    account_no: this.ui.accountNoSelect.val(),
                    currency: this.ui.currencyAbbr.val(),
                    method_text: window.method_text
                },
                success: function(data, res){

                    that.ui.balance.html(data.currency_symbol+' '+data.balance);
                    that.ui.totalBonus.html(data.currency_symbol+' '+data.total_bonus);
                    that.ui.withdrawableSymbol.html(data.currency_symbol+' ');
                    that.ui.withdrawableAmount.html(data.withdrawable);
                },
                error: function(data, error){

                }
            })
        },

        submit: function(e) {
            $('.ct_btn8').attr('disabled', true);
            if(e) e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this);

            this.form.set( formData);
            var errors = this.form.validate();

            var that = this;
            if(_.size(errors) < 1){
              $('#holdon-overlay').css("display", "");

              this.form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();
                    },
                    error: function(model, error){
                      $('#holdon-overlay').css("display", "none");

                      that.triggerMethod('show:errors', error.responseJSON);
                        $('.ct_btn8').attr('disabled', false);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
                $('.ct_btn8').attr('disabled', false)
            }
        }
    });
});
